module.exports = __webpack_public_path__ + "static/media/4.84088a06.gif";